import axios from "axios";
import config from "configs/config";
import { toast } from "react-toastify";

const baseURL = String(process.env.REACT_APP_CREATE_SERVER_URL || config.baseUrl || "").replace(/\/$/, "");

const createApiClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

createApiClient.interceptors.request.use(
  (reqConfig) => {
    if (reqConfig.data instanceof FormData) {
      delete reqConfig.headers["Content-Type"];
    }

    return reqConfig;
  },
  (error) => Promise.reject(error)
);

createApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const errorMessage = error.response.data.message;
      toast.error(errorMessage);
    }
    return Promise.reject(error);
  }
);

export default createApiClient;
